// extracted by mini-css-extract-plugin
module.exports = {"promoBlock":"uxlRE","image":"aJhVF","theme_rounded":"_1wYOg"};